import axios from "axios";

import ActivitiesApi from "./Activities";
import AgentsApi from "./Agents";
import AllowancesApi from "./Allowances";
import AuditsApi from "./Audits";
import BillingApi from "./Billing";
import BookingsApi from "./Bookings";
import CardsApi from "./Cards";
import CreditCardsApi from "./CreditCards";
import CreditLimitsApi from "./CreditLimits";
import ExpenseRequestsApi from "./ExpenseRequests";
import GroupsApi from "./Groups";
import GroupRulesApi from "./GroupRules";
import InfoApi from "./Info";
import MccsApi from "./Mccs";
import ManagersApi from "./Managers";
import MeApi from "./Me";
import MediasApi from "./Medias";
import NotificationsApi from "./Notifications";
import OffersApi from "./Offers";
import OtpApi from "./Otp";
import PartnersApi from "./Partners";
import PayoutsApi from "./Payouts";
import PaymentIntentsApi from "./PaymentIntents";
import PaymentMethodsApi from "./PaymentMethods";
import PaymentTransactionsApi from "./PaymentTransactions";
import PermissionsApi from "./Permissions";
import RolesApi from "./Roles";
import StatsApi from "./Stats";
import SpendingLimits from "./SpendingLimits";
import StoresApi from "./Stores";
import TagsApi from "./Tags";
import TypesApi from "./Types";
import IntegrationsApi from "./Integrations";
import UsersApi from "./Users";
import VoucherListsApi from "./VoucherLists";
import VouchersApi from "./Vouchers";
import WalletsApi from "./Wallets";
import WalletTransactionsApi from "./WalletTransactions";
import LicensesApi from "./Licenses";

const controller = new window.AbortController();
const axiosHelpers = require("axios-helpers");
let api = axiosHelpers(
    axios.create({
        baseURL: "https://api.hexeko.com/api/v1",
        crossdomain: true,
        headers: {
            "Content-Type": "application/json",
        },
        timeout: 100000,
        signal: controller.signal,
    })
);

api.activities = ActivitiesApi;
api.agents = AgentsApi;
api.allowances = AllowancesApi;
api.audits = AuditsApi;
api.billing = BillingApi;
api.bookings = BookingsApi;
api.cards = CardsApi;
api.creditCards = CreditCardsApi;
api.creditLimits = CreditLimitsApi;
api.expenseRequests = ExpenseRequestsApi;
api.groups = GroupsApi;
api.groupRules = GroupRulesApi;
api.info = InfoApi;
api.mccs = MccsApi;
api.managers = ManagersApi;
api.me = MeApi;
api.medias = MediasApi;
api.notifications = NotificationsApi;
api.offers = OffersApi;
api.otp = OtpApi;
api.partners = PartnersApi;
api.payouts = PayoutsApi;
api.paymentIntents = PaymentIntentsApi;
api.paymentMethods = PaymentMethodsApi;
api.paymentTransactions = PaymentTransactionsApi;
api.permissions = PermissionsApi;
api.roles = RolesApi;
api.stats = StatsApi;
api.spendingLimits = SpendingLimits;
api.stores = StoresApi;
api.tags = TagsApi;
api.types = TypesApi;
api.integrations = IntegrationsApi;
api.users = UsersApi;
api.voucherLists = VoucherListsApi;
api.vouchers = VouchersApi;
api.wallets = WalletsApi;
api.walletTransactions = WalletTransactionsApi;
api.licenses = LicensesApi;

export default api;
